/* assets/mega-menu.js */
(function () {
  'use strict';

  var HOVER_OK = window.matchMedia
    ? window.matchMedia('(hover: hover)').matches
    : true;

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function initMegaMenu(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.desk-nav [data-has-mega]');
    if (!items.length) return;

    items.forEach(function (li) {
      if (li.dataset.mmInitialized === 'true') return; // avoid double-binding
      var btn = li.querySelector('.navigation__expand-sublinks');
      var panel = li.querySelector('.mega-menu');
      if (!btn || !panel) return;

      li.dataset.mmInitialized = 'true';

      var enterTimer, leaveTimer;

      function open() {
        li.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      }
      function close() {
        li.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      }
      function toggle(e) {
        e && e.preventDefault();
        if (li.classList.contains('is-open')) close();
        else open();
      }

      // Hover (only on devices that actually hover)
      if (HOVER_OK) {
        li.addEventListener('mouseenter', function () {
          clearTimeout(leaveTimer);
          enterTimer = setTimeout(open, 80);
        });
        li.addEventListener('mouseleave', function () {
          clearTimeout(enterTimer);
          leaveTimer = setTimeout(close, 120);
        });
      }

      // Click / tap
      btn.addEventListener('click', toggle);

      // Keyboard: open on ArrowDown, close on Esc
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          open();
          var firstFocusable = panel.querySelector('a, button');
          if (firstFocusable) firstFocusable.focus();
        }
        if (e.key === 'Escape') {
          close();
          btn.focus();
        }
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
          btn.focus();
        }
      });

      // Close if focus fully leaves the <li>
      li.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!li.contains(document.activeElement)) close();
        }, 0);
      });
    });

    // Global handlers (one-time)
    if (!document.documentElement.dataset.mmGlobals) {
      document.documentElement.dataset.mmGlobals = 'true';

      // Click outside to close
      document.addEventListener('click', function (e) {
        var openItems = document.querySelectorAll('.desk-nav [data-has-mega].is-open');
        openItems.forEach(function (openLi) {
          if (!openLi.contains(e.target)) {
            var btn = openLi.querySelector('.navigation__expand-sublinks');
            var panel = openLi.querySelector('.mega-menu');
            openLi.classList.remove('is-open');
            btn && btn.setAttribute('aria-expanded', 'false');
            panel && panel.setAttribute('aria-hidden', 'true');
          }
        });
      });

      // Esc anywhere closes all
      document.addEventListener('keyup', function (e) {
        if (e.key !== 'Escape') return;
        var openItems = document.querySelectorAll('.desk-nav [data-has-mega].is-open');
        openItems.forEach(function (openLi) {
          var btn = openLi.querySelector('.navigation__expand-sublinks');
          var panel = openLi.querySelector('.mega-menu');
          openLi.classList.remove('is-open');
          btn && btn.setAttribute('aria-expanded', 'false');
          panel && panel.setAttribute('aria-hidden', 'true');
        });
      });

      // Re-init when the header section reloads in Theme Editor
      document.addEventListener('shopify:section:load', function (evt) {
        if (closest(evt.target, '[data-section-type="header-section"]')) {
          initMegaMenu(evt.target);
        }
      });
    }
  }

  // Init on DOM ready (works great with defer)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMegaMenu(); });
  } else {
    initMegaMenu();
  }

  // Expose for debugging if needed
  window.WyzeMegaMenu = { init: initMegaMenu };
})();
